import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Lager 1",
  viewBox: "0 0 500 500"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#F9D10B",
      d: "M487.86 264.48 344.21 398.04c-7.98 7.43-20.48 6.98-27.91-1-7.45-8-7-20.51 1-27.94l106.93-99.37H25.59c-10.9 0-19.74-8.84-19.74-19.74 0-5.46 2.21-10.39 5.78-13.96 3.58-3.57 8.52-5.78 13.96-5.78h398.58L317.3 130.91c-8-7.43-8.45-19.94-1-27.94a19.73 19.73 0 0 1 14.46-6.29c4.82 0 9.65 1.75 13.45 5.29l143.65 133.59c8.41 7.81 8.41 21.13 0 28.94Z"
    }, null, -1)
  ]))]))
}
export default { render: render }